<template>
  <span
    :class="[
      'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium',
      priorityClasses
    ]"
  >
    {{ priority }}
  </span>
</template>

<script>
export default {
  name: 'TicketPriorityBadge',
  props: {
    priority: {
      type: String,
      required: true
    }
  },
  computed: {
    priorityClasses() {
      const priorityMap = {
        'High': 'bg-red-100 text-red-800',
        'Medium': 'bg-yellow-100 text-yellow-800',
        'Low': 'bg-green-100 text-green-800'
      };
      return priorityMap[this.priority] || 'bg-gray-100 text-gray-800';
    }
  }
};
</script>
